module.exports = __webpack_public_path__ + "img/35.69407137.png";